import React from 'react';
import { formatIAFType } from '../../lib/helpers/formatters';

function IAFTypeField({ value }) {
  return <>{formatIAFType(value)}</>;
}

export default IAFTypeField;
